import { supabase } from '@/lib/supabase';
import type { MetricsSeriesRow } from '@/types';

export type MetricsSeriesParams = {
  component?: string;
  metric?: string;
  since?: string;
};

export const metricsApi = {
  series: async (params: MetricsSeriesParams = {}): Promise<MetricsSeriesRow[]> => {
    const { data, error } = await supabase.rpc('admin_metrics_series', {
      p_component: params.component ?? null,
      p_metric: params.metric ?? null,
      p_since: params.since ?? null,
    });
    if (error) throw error;
    return (data ?? []) as MetricsSeriesRow[];
  },
};
